const lore = (
    <>
        <h1 className="mitten"> 
            <span className="viking-font">VÄlKOMMeN N0llan</span>
        </h1>

        <p className="mitten">
            I begynnelsen fanns ingenting, <br />
            Inte ens tiden själv.
        </p>

        <p  className="mitten">
            Tidens egna klocka hade ännu inte börjat ticka, <br />
            För ännu fanns inget Fadderi.
        </p>
            
        <p>
           
            Ur intet framträdde Generalen och slog universums första, starkaste klockslag.
            Det ringade genom tid och rum, och gav liv och rörelse till den värld som
            tidigare varit stel och tyst.
            Generalen förutspådde <span className="viking-font">N0lle-P</span> långt innan
            <span className="viking-font"> N0llan </span> och dess förfäder fanns i denna värld,
            och svor att för evigt använda sina allsmäktiga krafter för att se till att vart skeende inträffar så som avsetts i all oändlighet.
        </p>

        <p>
            Men inte ens Generalen själv kan kontrollera tidens intensiva puls. Därav
            delade hon tiden i 12. Hon skapade 11 ytterligare varelser, nästan lika allsmäktiga
            som hon själv, för att alla övervaka varsin timme av dygnet. Så kom det
            allsmäktiga <span className="viking-font">gUDfADDerieT</span> till.
        </p>
            
        <p>
            Generalen vakar över den första timmen på dygnet och står därav med en fot
            i nuet och en i framtiden, och styr på så sätt var minsta dels sekund av tiden.
            Hennes trogna följeslagare bevakar själva varsin timme på klockan och ser till
            att denna timme förblir hel, ty kaos råda om en timme skulle rasera.
            För att skydda <span className="viking-font">N0llan</span> måste var Fadderist bestyra var timme så att de
            händelser som utspelar sig under denna är de som förutspåtts sedan
            begynnelsen.
        </p>

        <p>
            Därav skall <span className="viking-font">N0llan</span> alltid höra till <span className="viking-font">gUDfADDerieT</span> och lyda
            dessa,
            ty <span className="viking-font">gUDfADDerieT</span>s ord är tidens lagar förkroppsligade.
        </p>

        <p  className="mitten">
            För tid och evighet, <br />
            Tidens Väktare, det allsmäktiga <span className="viking-font">gUDfADDerieT</span>
        </p>
    </>
);
export default lore;